<template>
  <div>
    <!-- Footer -->
    <div
      class="position-absolute start-0 w-100 d-flex align-items-center"
      style="height: 150px; padding: 0px 40px; bottom: 40px"
    >
      <div class="d-flex justify-content-between w-100">
        <div style="line-height: 1.2">
          <small
            class="text-muted"
            style="font-size: 10.2px; line-height: 1.2; display: block"
          >
            {{
              $t(
                `project.previewAndReport.reportTypes.${reportType}.footer.copyright`
              )
            }}
          </small>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "ReportFooter",
  props: {
    reportType: {
      type: String,
      required: true,
    },
  },
});
</script>
